import script from "./customButtonV2.vue?vue&type=script&setup=true&lang=js"
export * from "./customButtonV2.vue?vue&type=script&setup=true&lang=js"

import "./customButtonV2.vue?vue&type=style&index=0&id=c61b4556&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c61b4556"]])

export default __exports__